export class AuthorizeNetProfileParams {
  constructor(data) {
    this.groupAdminId = data.groupAdminId;
  }
}
